export default __webpack_public_path__ + "static/media/man-double-bass.4d1a3461.jpg";